import React, { useState, useEffect, useRef } from 'react';
import axios from 'axios';
import { Form, Button, Alert, Container, Row, Col, Card } from 'react-bootstrap';
import { FaLinkedin } from 'react-icons/fa';
import socialMediaImg from '../linkedinGraph.png';
import heroLogo from "../Untitled_design_7_o9dfvi_c_crop,w_1116,h_628,ar_16_9.png";


const SocialMediaLeadsForm = () => {

    const heroRef = useRef(null);
    const [showLogo, setShowLogo] = useState(false);
    const [formData, setFormData] = useState({
        name: '',
        email: '',
        phone: '',
        address: '',
        message: 'Saw your post on LinkedIn about streamlining HR software — I’d love to learn more about how your solution could support our team.',
    });

    const [status, setStatus] = useState({ success: null, message: '' });

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((prev) => ({ ...prev, [name]: value }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            await axios.post('https://crm-function-app.herokuapp.com/api/contactus', formData);
            setStatus({ success: true, message: 'Message sent successfully!' });
            setFormData({ name: '', email: '', phone: '', address: '', message: '' });
        } catch (err) {
            setStatus({ success: false, message: 'Something went wrong. Please try again later.' });
        }
    };
    useEffect(() => {
        const timer = setTimeout(() => {
            const container = heroRef.current;
            if (container) {
                const oldH = container.getBoundingClientRect().height;
                setShowLogo(true);
                requestAnimationFrame(() => {
                    const newH = container.getBoundingClientRect().height;
                    container.style.height = `${oldH}px`;
                    container.style.transition = 'height 1.6s ease';
                    requestAnimationFrame(() => {
                        container.style.height = `${newH}px`;
                    });
                    setTimeout(() => {
                        container.style.height = '';
                        container.style.transition = '';
                    }, 100);
                });
            } else {
                setShowLogo(true);
            }
        }, 100); // Adjust delay here (8s)

        return () => clearTimeout(timer);
    }, []);
    return (


        <Container className="mt-5">
            <Row className="justify-content-center">
                <Col md={8}>
                    <div ref={heroRef} style={{ overflow: 'hidden', textAlign: 'center', marginBottom: '2rem' }}>
                        {showLogo && (
                            <>
                                <img
                                    src={heroLogo}
                                    alt="Social Logo"
                                    style={{
                                        display: 'block',
                                        margin: '0 auto',
                                        height: 'auto',
                                        maxWidth: '300px',
                                        borderRadius: '12px',
                                    }}
                                />
                                <h2
                                    style={{
                                        backgroundImage: 'linear-gradient(to right, darkblue, #00c6ff)',
                                        WebkitBackgroundClip: 'text',
                                        color: 'transparent',
                                        WebkitTextFillColor: 'transparent',
                                        fontWeight: 'bold',
                                        fontFamily: 'cursive',
                                        marginTop: '1rem',
                                    }}
                                >
                                    Social Media Lead Generation
                                </h2>
                            </>
                        )}
                    </div>
                    <Card
                        className="p-4 shadow"
                        style={{
                            background: 'linear-gradient(to right, #0072b1, #00c6ff)',
                            borderRadius: '1rem',
                            color: 'white',
                            boxShadow: '0 8px 20px rgba(0, 0, 0, 0.2)'
                        }}
                    >


                        <Card.Img
                            variant="top"
                            src={socialMediaImg}
                            style={{
                                maxHeight: '200px',
                                objectFit: 'cover',
                                borderRadius: '0.5rem',
                                marginBottom: '1rem',
                                boxShadow: '0 4px 12px rgba(0,0,0,0.3)'
                            }}
                        />
                        <Card.Title className="text-center mb-2" style={{ fontSize: '1.4rem', fontWeight: '700' }}>
                            <FaLinkedin style={{ color: '#0077B5', marginRight: '0.5rem', verticalAlign: 'middle' }} />
                            Connect with Decision-Makers on LinkedIn
                        </Card.Title>
                        <img
                            src={heroLogo}
                            alt="Website Lead Example"
                            style={{
                                display: 'block',
                                margin: '0 auto',
                                height: 'auto',
                                maxWidth: '300px',
                                borderRadius: '12px'
                            }}
                        />
                        <p className="text-center" style={{ fontStyle: 'italic', fontWeight: '500', fontSize: '1.1rem', color:'white' }}>
                         Let’s take the next step here on LinkedIn. Whether you're interested in B2B partnerships,
                            hiring, or software solutions — we’ll get you connected to the right person, fast.
                        </p>

                        {status.message && (
                            <Alert variant={status.success ? 'success' : 'danger'}>
                                {status.message}
                            </Alert>
                        )}

                        <Form onSubmit={handleSubmit}>
                            <Form.Group className="mb-3" controlId="formName">
                                <Form.Label>Name</Form.Label>
                                <Form.Control
                                    type="text"
                                    name="name"
                                    value={formData.name}
                                    onChange={handleChange}
                                    placeholder="Your full name"
                                    required
                                />
                            </Form.Group>

                            <Form.Group className="mb-3" controlId="formEmail">
                                <Form.Label>Email</Form.Label>
                                <Form.Control
                                    type="email"
                                    name="email"
                                    value={formData.email}
                                    onChange={handleChange}
                                    placeholder="you@example.com"
                                    required
                                />
                            </Form.Group>

                            <Form.Group className="mb-3" controlId="formPhone">
                                <Form.Label>Phone</Form.Label>
                                <Form.Control
                                    type="tel"
                                    name="phone"
                                    value={formData.phone}
                                    onChange={handleChange}
                                    placeholder="(555) 123-4567"
                                />
                            </Form.Group>

                            <Form.Group className="mb-3" controlId="formAddress">
                                <Form.Label>Address</Form.Label>
                                <Form.Control
                                    type="text"
                                    name="address"
                                    value={formData.address}
                                    onChange={handleChange}
                                    placeholder="123 Main St, City, State"
                                />
                            </Form.Group>

                            <Form.Group className="mb-3" controlId="formMessage">
                                <Form.Label>Message</Form.Label>
                                <Form.Control
                                    as="textarea"
                                    rows={4}
                                    name="message"
                                    value={formData.message}
                                    onChange={handleChange}
                                />
                            </Form.Group>

                            <div className="d-grid">
                                <Button variant="primary" type="submit">Have someone reach out</Button>
                            </div>
                        </Form>
                    </Card>
                </Col>
            </Row>
        </Container>
    );
};

export default SocialMediaLeadsForm;
